import React, { useMemo, useState, useEffect, useRef } from 'react';
import { connect, history } from 'umi';
import {
  Button,
  Checkbox,
  Icon,
  Layout,
  Modal,
  // Tabs
} from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import { Bubble } from '@home/components/TeaComponents';
import HeaderDetails from '@/pages/intelligence/components/HeaderDetails';
// tab下子页面
import Overlay from './Overview';
// combine游戏详情KPIOverview页面
import KPIOverview from './KPIOverview';
import GameInfo from './GameInfo';
import Stats from './Stats';
import KPITrends from './KPITrends';
import Countries from './Countries';
import StoreRank from '@/pages/intelligence/pages/TopCharts/components/StoreRankDetails';
import Opinions from './Opinions';
import Streaming from './Streaming';
import Demographics from './Demographics/Page';
import Overlap from './Overlap';
import OverlapSteam from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/OverlapSteam';
import classNames from 'classnames';
import { formatReleaseTime } from '@home/components/NavHeader/sreachContext/utils';
import { getZhouToCountryList } from '@/pages/intelligence/utils/topchartsUtils';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import '@/pages/intelligence/assets/scss/TopCharts/components/GamesDetails/index.scss';
import HeaderComonents from '@/pages/intelligence/pages/TopCharts/components/DetailsPage/HeaderComonents';
import { getjpnSalesTimeRange, getRainbowApi } from '@/pages/intelligence/services/topcharts';
import { getOptions } from '@intelligence/components/GenreSelectMiddleware/Supports/services';
import PublicTrueData from '@/pages/intelligence/components/PublicTrueData';
import { dbiPageLogMes, list } from '@/pages/intelligence/utils/buriedPointCfg';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/CommonComponents/NoData';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import GameImage from '@/pages/home/components/GameImage';
import './index.scss';
import FixedHeader from './FixedHeader';
import { COMPETITOR_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/Competitor';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { useQueryDefinition } from '@intelligence/hooks/useQueryDefinition';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { createGameBasicinfoFetcher } from './services';
import type { IGameType } from '@/pages/intelligence/types/common';
import { getBasePath } from '@/utils/utils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import JumpDashboardModal from '@/pages/intelligence/components/JumpDashboardModal';
import { URL_APP_IDS, getOriginalShortLinkFilter, URL_FILTER_KEY } from '@intelligence/utils/urlPathCfg';
import {
  useActiveIdState,
  newMarkIdsMappingKeys,
  useUserGuideCompetitorHelper,
  useResetPositionWhenTabChange,
  checkValidQuery,
} from './utils';
import { OPINIONFEEDSGAMES } from '@/pages/home/components/NavHeader/_config';
import { IS_GLOBAL } from '@/pages/home/_config/config';
import useMetricsDateRange from '@intelligence/v3/_hooks/useMetricsDateRange';
import useGamesDetailsModel from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/hooks/useGamesDetailsModel';
import useGameComparison from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/hooks/useGameComparison';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import usePublicTrueDataModel from '@/pages/intelligence/components/PublicTrueData/hooks/usePublicTrueDataModel';
import { fetchUserSearchTrendingStatus } from '@/pages/home/services/search';
import { getGameInfoByIdPlus } from '@intelligence/services/common';
import moment from 'moment';
import { isEmpty, parseJSONString } from '@intelligence/v3/utils/common';
import { validateGameId } from '@intelligence/v3/utils/topcharts';
import { DATASOURCE_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import PermissionGuard from '@intelligence/v3/pages/TopCharts/MobileGames/_components/PermissionGuard';
import {
  getCountroesPageLogMes,
  getStatsPageLogMes,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_config';
const { Content } = Layout;

const MOBILE_DETAIL_PERMISSION_EXCLUDED_TAB_IDS = ['storeRank', 'streaming'];

const MOBILE_DETAIL_PERMISSION_GUARD_STYLE: React.CSSProperties = {
  height: 'calc(100vh - 187px - 60px)',
};

const MOBILE_OVERLAP_METRICS = [
  DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE,
  DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_AFFINITY,
];
function MobileGamesDetails(props: any) {
  const { dispatch, topchartsState, userInfo, entityType = 'mobile', moduleName = 'mobileGames' } = props;
  const newMarkIdsMappingKey = newMarkIdsMappingKeys[entityType];
  const { loadingStd: definitionsLoading, genreOptionsMap, filterTags } = useQueryDefinition();
  const { resetDetailFilterExtend } = useFilterExtend({});

  const basePath = getBasePath();
  const getGameBasicinfo = createGameBasicinfoFetcher(entityType);

  /** 清空继承值逻辑
   * 1 详情页头部点击跳转到不同版本游戏时
   * 2 在情报榜单或详情点击顶部搜索游戏并点击游戏时
   * 3 在首页点击游戏进来详情，操作过筛选器后点浏览器返回首页
   * 1 详情页相似游戏跳转 //TODO
   * */
  useEffect(
    () =>
      // 离开详情时，清空详情的继承值
      () => {
        const { pathname } = window.location; // 不要在外面取，会异步
        if (!(pathname.startsWith('/search') || pathname?.startsWith(`${getBasePath()}/search`))) {
          resetDetailFilterExtend();
        }
      },
    [],
  );

  const isConsoleOrPCConsoleCombine = ['console', PC_CONSOLE_COMBINE_ENTITY_TYPE].includes(
    entityType,
  );
  const { locale, formatMessage } = useIntlExtend();
  // 通用四个详情页参数
  const tabSegment = props?.match?.params?.segment || '';
  const gameId = props?.match?.params?.id || '';
  const openTrue = Boolean(props?.location?.query?.openTrue) || false;
  const [activeId, setActiveId] = useActiveIdState(entityType, props?.match?.params?.tab);
  // 增加纯国家列表以用来简称匹配全称用
  const [countryList, setCountryList] = useState<any>([]);
  // 增加纯国家列表以用来简称匹配全称用
  const [regionsCountries, setRegionsCountries] = useState<any>([]);
  // 获取全局国家地区数据
  const { regionOptions } = useMarketFilterApi({});
  const [urlFilterValue, setUrlFilterValue] = useState(null);

  useEffect(() => {
    setRegionsCountries(regionOptions);
  }, [regionOptions]);

  // 是否为校准数据
  const [isCalibrated, setIsCalibrated] = useState(false);
  const [ifUnifiedGo, setIfUnifiedGo] = useState(true);
  const [isSingle, setIsSingle] = useState(false);
  const [loading, setLoading] = useState(true);
  const [headLoading, setHeadLoading] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);
  const [basicInfo, setBasicInfo] = useState<any>({});
  // detail_plus接口返回的游戏详情数据
  const [gameDetails, setGameDetails] = useState<IRecord | null>(null);
  const [basicInfoOthers, setBasicInfoOthers] = useState<any>({});
  const [appIdListAll, setAppIdListAll] = useState([]); // 当前游戏总APPIDlist
  const [appIdsAll, setAppIdsAll] = useState<string[]>([]); // 当前游戏总APPIDlist(id)
  const [appIdList, setAppIdList] = useState<any>([]); // 当前游戏已选APPID，纯ids
  const [req, setreq] = useState({});
  const [hrefFlag, setHref] = useState(false);
  const [isTwoMonths, setIsTwoMonths] = useState(false);
  const [unPublishedAppIdList, setUnPublishedAppIdList] = useState([]);
  const [inactiveAppIdList, setInactiveAppIdList] = useState<string[]>([]);
  const [appInfoList, setAppInfoList] = useState([]);
  const [isIegg, setIsIegg] = useState(false);
  // 从子组件提取出来，解决重置问题
  const [detailIndex, setDetailIndex] = useState([]);
  // 游戏占用内存 string
  const [storage, setStorage] = useState('');
  const [hasJapanSales, setHasJapanSales] = useState(!!topchartsState.isHasJapanSalesTop);
  const filter = decodeURIComponent(location.search?.split('filter=')[1] || ''); // 地址栏拿到相关信息
  const filterObj = parseJSONString({}, filter);
  const sourse = filterObj?.sourse || 'appannie'; // 要展示的默认平台数据
  const regionType = filterObj?.regionType || 'region';
  const regions = filterObj?.regions?.map((item: any) => item?.toString()?.toLocaleLowerCase()) || ['global'];
  const timeType = filterObj?.timeType || '';
  const filterAppids = filterObj?.app_ids || [];
  // summary 和 about 接口需要的参数
  const marketRegionType = filterObj?.marketRegionType || regionType;
  const marketRegionValue = filterObj?.marketRegionValue || regions;
  const releaseTime = formatReleaseTime(locale, {
    realReleaseTime: basicInfo?.real_release_time,
    isSpecialReleaseTime: basicInfo?.is_special_release_time,
    releaseTime: basicInfo?.release_time,
    releaseTimeEN: basicInfo?.release_time_en,
    releaseTimeCN: basicInfo?.release_time_cn,
  });
  const initNote = () => {
    if (entityType === 'mobile' || entityType === 'combine') return;
    info30Note();
  };

  // 默认提示弹窗状态
  const [infoNote, setInfoNote] = useState(false);
  // 游戏详情公共hooks，数据管理,所有子tab内容接口调用都在此hooks处理
  const {
    defaultActiveSegment,
    getCombinedGameId,
    showOpinion,
    opinionId,
    dashboardGameCode,
    ifShowDashboardTips,
    overlapAppIdsLoading,
    combineGameIdList,
    setIfShowDashboardTips,
    getIsDemographics,
    isDemographics,
    demographicsIdsList,
    demographicsIdsLoaded,
    appOverlapSteamId,
    isDisabledSteamOverlap,
    getTrendGameList,
    isDisabledDataReport,
    dataReportGameId,
    getFeedbackBasicInfo,
    handleFeedbackSubmit,
    isFeedbackLoading,
  } = useGamesDetailsModel({
    entityType,
    gameId,
    basicInfo,
    topchartsState,
    appIdList,
    initNote,
  });

  const [activeSegment, setActiveSegment] = useState(props?.match?.params?.segment || defaultActiveSegment);
  // 记录当前游戏是否手动切换过指标，避免 Stats 重挂载后再次执行首次自动跳转。
  const manualStatsSegmentGameIdRef = useRef('');
  const markManualStatsSegmentSwitch = () => {
    manualStatsSegmentGameIdRef.current = gameId;
  };
  const isManualStatsSegmentSwitch = () => manualStatsSegmentGameIdRef.current === gameId;
  // 游戏详情
  const [gameData, setGameData] = useState(null);

  const [selectGameName, setSelectGameName] = useState('');

  const { loading: metricsDateRangesLoading, dateRangeMap: metricsDateRangeMap } = useMetricsDateRange(
    entityType === 'mobile' && !loading,
    {
      game_ids: gameId ? [gameId] : [],
      app_ids: appIdsAll || [],
      granularities: ['monthly'],
      markets: [],
      metrics: [...MOBILE_OVERLAP_METRICS],
      group_by: [],
    },
  );

  // Game Comparison hook - handles navigation to Compare page with current game + competitors
  const { navigateToComparison } = useGameComparison({
    entityType,
    gameId,
    appIdsAll,
    regionType,
    regions,
    preloadedCompetitors: basicInfoOthers?.similar_apps || basicInfoOthers?.similar_games || [],
  });

  const isOverlapDisabled = useMemo<boolean>(() => {
    if (metricsDateRangesLoading) {
      return true;
    }

    if (isEmpty(metricsDateRangeMap)) {
      return true;
    }

    return !MOBILE_OVERLAP_METRICS.some((metric) => {
      const metricsDateRangeMapKey = `monthly__${metric}`;
      return !!metricsDateRangeMap[metricsDateRangeMapKey];
    });
  }, [metricsDateRangesLoading, metricsDateRangeMap]);

  // segment 参数变动时，更新 activeSegment 状态，避免初始值获取不到
  useEffect(() => {
    const newSegment = props?.match?.params?.segment || defaultActiveSegment;
    // 只由路由参数变化驱动，避免旧路由参数回滚指标点击时刚更新的本地状态
    setActiveSegment((currentSegment) =>
      currentSegment === newSegment ? currentSegment : newSegment,
    );
  }, [props?.match?.params?.segment, defaultActiveSegment]);

  useUserGuideCompetitorHelper(entityType, {
    activeId,
    setActiveId,
    activeSegmentId: activeSegment,
    setActiveSegmentId: setActiveSegment,
  });

  // 接收子组件传过来函数
  const receiverSum = (context: any) => {
    getHead_info([context?.rowKey]); // 点击表格行跳转
    setAppIdList([context?.rowKey]);
    const arr = topchartsState.appIdsBackup;
    arr.push([context?.rowKey]);
    dispatch({ type: `${DBI_TOPCHARTS}/setAppIdsBackup`, payload: arr });
    setLoadingSub(true);
  };

  // 接收从头部组件更改APPid，所执行函数
  const changeAppIds = (appIds: any, platform: any, ifLoading = true) => {
    getHead_info(appIds, ifLoading);
    const arr = topchartsState.appIdsBackup;
    arr.push(appIds);
    dispatch({ type: `${DBI_TOPCHARTS}/setAppIdsBackup`, payload: arr });
  };

  // 通过七彩石接口，获取当前游戏是否有下架时间，下架时间是多少
  const getIfPullOffGame = async (id: any) => {
    try {
      const res = await getRainbowApi({
        key: 'get_time',
        group: 'game_pull_off_shelves.config',
      });
      if (Array.isArray(res?.data?.rows)) {
        const offGameInfo = JSON.parse(res.data.rows[0].value);
        dispatch({
          type: `${DBI_TOPCHARTS}/setLowerGameTime`,
          payload: offGameInfo.pull_off_time || [],
        });
        dispatch({
          type: `${DBI_TOPCHARTS}/setIslowerGame`,
          payload: id === offGameInfo.game_id,
        });
      }
    } catch (err) {}
  };

  const updateGameDetails = async () => {
    if (!gameId) {
      return;
    }

    // Define custom_fields based on entity type
    // Mobile: includes genre-related fields for Sensor Tower and App Magic tags
    // PC/Console/Combine: only needs game_engine field
    const mobileCustomFields = [
      'sensortower_genre',
      'sensortower_sub_genre',
      'iegg_genre',
      'iegg_sub_genre',
      'super_genre',
      'major_category',
      'mid_category',
      'sub_category',
      'minor_category',
      'ext_json',
      'game_engine',
    ];
    const pcConsoleCustomFields = ['game_engine'];

    const customFields = entityType === 'mobile' ? mobileCustomFields : pcConsoleCustomFields;

    try {
      const res = await getGameInfoByIdPlus({
        entity_type: entityType,
        level: 'custom',
        custom_fields: customFields,
        ids: [gameId],
      });
      const gameDetails = res?.data?.[gameId];
      const extJSON = parseJSONString({}, gameDetails?.ext_json);
      setGameDetails({ ...gameDetails, ext_json: extJSON });
    } catch (exception) {
      console.error(exception);
    }
  };

  const getHead_info = async (appIds: any, ifLoading = true) => {
    ifLoading && setHeadLoading(true);
    setLoading(true);
    const isPCConsoleCombineOverview = entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE;
    const baseParams = {
      entity_type: entityType || 'mobile',
      id: gameId,
      app_id: appIds,
      region_type: regionType || 'region',
      regions: regions?.length ? regions : ['global'],
      about: isPCConsoleCombineOverview ? 1 : 0,
      similar_game: isPCConsoleCombineOverview ? 1 : 0,
    };
    const jpnSalesTimeParams = {
      edition_id: gameId,
    };
    const baseAndStore = [
      getGameBasicinfo(baseParams),
      getOptions('mobile'),
      isConsoleOrPCConsoleCombine ? getjpnSalesTimeRange(jpnSalesTimeParams) : '',
    ];
    try {
      updateGameDetails();
      const [baseResult, storeRegionResult, jpnResult = {}] = await Promise.all(baseAndStore);
      const { [URL_FILTER_KEY]: urlFilter, [URL_APP_IDS]: urlAppidList } = await getOriginalShortLinkFilter();
      setUrlFilterValue(urlFilter);
      const { basic_info, app_id_info, app_id_list: rawAppIdList, ...rest } = baseResult?.data || {};
      const inactiveMap = new Map(
        (app_id_info || []).map((info: any) => [info.id, info.inactive]),
      );
      const app_id_list = (rawAppIdList || []).map((item: any) => ({
        ...item,
        inactive: inactiveMap.get(item.id) ?? item.inactive,
      }));
      // 设置当前游戏信息
      setGameData(basic_info);
      setSelectGameName(basic_info?.name);
      const { release_dates_by_platform = '' } = baseResult?.data || {};
      const { max_date, min_date } = jpnResult?.data || {};
      const appIdsTmp = app_id_list?.map((item: any) => item?.id) || [];
      const headerReleaseDate = formatReleaseTime(
        locale,
        {
          realReleaseTime: basic_info?.real_release_time,
          isSpecialReleaseTime: basic_info?.is_special_release_time,
          releaseTime: basic_info?.release_time,
          releaseTimeEN: basic_info?.release_time_en,
          releaseTimeCN: basic_info?.release_time_cn,
        },
        '',
      );
      const validHeaderReleaseDate = moment(headerReleaseDate, 'YYYY-MM-DD', true).isValid()
        ? headerReleaseDate
        : '';
      const releaseInfoForDateFilter = {
        releaseTime: validHeaderReleaseDate || basic_info?.release_time || '',
        releaseMonth: validHeaderReleaseDate || basic_info?.release_month || '',
        releaseWeek: validHeaderReleaseDate || basic_info?.release_week || '',
      };
      if (entityType === 'mobile') {
        /** IsDemographics接口判断Demographics标签是否置灰 */
        getIsDemographics(appIdsTmp);
      }
      // 通过idList获取
      const source_desc = basic_info?.source_desc || '';
      const { annir = [], ieg = [], region_country = [] } = storeRegionResult?.data || {};
      dispatch({ type: `${DBI_TOPCHARTS}/setIeggGenreTotal`, payload: ieg });
      dispatch({ type: `${DBI_TOPCHARTS}/setAnnieGenreTotal`, payload: annir });
      dispatch({
        type: `${DBI_TOPCHARTS}/setJpnSalesMaxdate`,
        payload: max_date || '',
      });
      dispatch({
        type: `${DBI_TOPCHARTS}/setJpnSalesMindate`,
        payload: min_date || '',
      });
      const booHasJapanSales = !!(max_date !== '' && min_date !== '');
      setHasJapanSales(booHasJapanSales);
      dispatch({
        type: `${DBI_TOPCHARTS}/setIsHasJapanSalesTop`,
        payload: booHasJapanSales,
      });
      // 从此接口获取到大洲国家数据，转为国家列表数据
      setCountryList(getZhouToCountryList(region_country));
      // 拿到游戏信息，去判断是否为有下架过的游戏
      getIfPullOffGame(basic_info?.id);
      // setGameName(basic_info?.name);
      // 判断是否为校准数据
      setIsCalibrated(source_desc === 'ogdb');
      setAppIdListAll(app_id_list);
      setAppIdsAll(appIdsTmp);
      setreq(baseResult?.req);
      setIsSingle(basic_info?.is_single_app_id);
      // 增加是否为2个月内发布的判断
      setIsTwoMonths(basic_info?.is_new);
      setIsIegg(basic_info?.is_iegg);
      setStorage(basic_info?.storage || '');
      if (activeId === 'overview') {
        dispatch({
          type: `${DBI_TOPCHARTS}/setTimeTypeOverview`,
          payload: timeType,
        });
        dispatch({
          type: `${DBI_TOPCHARTS}/setRegionTypeOverview`,
          payload: regionType,
        });
        dispatch({
          type: `${DBI_TOPCHARTS}/setRegionsOverview`,
          payload: regions,
        });
      }
      dispatch({ type: `${DBI_TOPCHARTS}/setIsOverviewFirst`, payload: false });
      dispatch({
        type: `${DBI_TOPCHARTS}/setBaseReleaseTime`,
        payload: releaseInfoForDateFilter.releaseTime,
      });
      dispatch({
        type: `${DBI_TOPCHARTS}/setBaseReleaseMonth`,
        payload: releaseInfoForDateFilter.releaseMonth,
      });
      dispatch({
        type: `${DBI_TOPCHARTS}/setBaseReleaseWeek`,
        payload: releaseInfoForDateFilter.releaseWeek,
      });
      dispatch({
        type: `${DBI_TOPCHARTS}/setReleaseDatesByPlatform`,
        payload: release_dates_by_platform || '',
      });
      setAppInfoList(app_id_info);
      // 这个逻辑是当初次访问overview页面时，不点游戏，直接访问Store Rank，appidlist需要传过去，就默认拿所有appinfo里面的id
      if (app_id_list?.length !== 0 && appIds?.length === 0) {
        // 短链接上有则优先用短链接，否则默认全选
        const appids = app_id_list?.map((item: { id: any }) => item.id);
        const currentAppids = checkValidQuery(urlAppidList, appids);
        setAppIdList(currentAppids);
        dispatch({
          type: `${DBI_TOPCHARTS}/setAppIdsSelected`,
          payload: currentAppids,
        });
      }
      // 无效数据，接口返回的basic_info 为null
      if (basic_info) {
        basic_info.mobileStoreRankRegion = storeRegionResult?.data?.region_country || [];
      }
      // Merge support_metrics (sibling of basic_info) into basicInfo for downstream access
      setBasicInfo(
        basic_info
          ? { ...basic_info, support_metrics: baseResult?.data?.support_metrics }
          : {},
      ); // 最后修改，保证其他state已同步完成
      setBasicInfoOthers(rest || {});
      if (appIds?.length == 0 || appIds?.length == app_id_list?.length) {
        setIfUnifiedGo(true);
      } else {
        setIfUnifiedGo(false);
      }
      const unPublishedList = app_id_list?.filter((v: any) => v?.unpublished === 1)?.map((v: any) => v?.id);
      setUnPublishedAppIdList(unPublishedList || []);
      const inactiveList = app_id_list?.filter((v: any) => v?.inactive === true)?.map((v: any) => v?.id);
      setInactiveAppIdList(inactiveList || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setHeadLoading(false);
    }
  };

  useEffect(() => {
    // 如果路由传来 Appids
    dispatch({ type: `${DBI_TOPCHARTS}/setAppIdsBackup`, payload: [] });
    getHead_info(filterAppids?.length > 0 ? filterAppids : []);
    // 与游戏头部信息一起查询，相关overlap/opinions的权限
    getCombinedGameId(entityType, gameId);
    // 与游戏头部信息一起查询，相关Data Report的权限
    getTrendGameList();
  }, [gameId]);



  const {
    tableFeedBackData,
    pageId: pageIdFeedBack,
    fetchTrueDataFeedbackHistory,
    setGameIdValue,
    setEntityTypeValue,
    gameIdValue,
    entityTypeValue,
    tableFeedBackDataTotal,
    feedBackParams,
    openFeedBackTable,
    setOpenFeedBackTable,
  } = usePublicTrueDataModel({
    gameId,
    entityType,
    openTrue,
  });

  const tabs = [
    {
      id: 'countries',
      label: formatMessage({ id: `dbi_countries` }),
      disabled: false,
      className: COMPETITOR_GUIDE_CLASSNAMES.ELEMENT4_HIGHLIGHT2,
      component: (
        <Countries
          isBasicLoading={loading}
          gameId={gameId}
          entityType={entityType}
          tabSegment={tabSegment}
          countryList={countryList}
          regionsCountries={regionsCountries}
          basicInfo={basicInfo}
          appIdListAll={appIdListAll}
          appIds={appIdList}
          unPublishedAppIdList={unPublishedAppIdList}
          tabType={'countries'}
          isCalibrated={isCalibrated}
          moduleName={moduleName}
          activeId={activeId}
          activeSegment={activeSegment}
          setActiveSegment={setActiveSegment}
          isTwoMonths={isTwoMonths}
          hasJapanSales={hasJapanSales}
          hasSteamData={combineGameIdList?.filter((item) => ['pc'].includes(item?.entity_type))?.length > 0}
          combineGameIdList={combineGameIdList}
          releaseInFortyDay={basicInfo?.is_forty_days}
          urlFilterValue={urlFilterValue}
        />
      ),
    },
    {
      id: 'storeRank',
      label: formatMessage({ id: `dbi_storeRank` }),
      disabled: false,
      component: (
        <StoreRank
          isBasicLoading={loading || overlapAppIdsLoading}
          gameId={gameId}
          entityType={entityType}
          basicInfo={basicInfo}
          appIdListAll={appIdListAll}
          appIds={appIdList}
          tabSegment={tabSegment}
          countryList={countryList}
          moduleName={moduleName}
          activeId={activeId}
          combineGameIdList={combineGameIdList}
          urlFilterValue={urlFilterValue}
        />
      ),
    },
    {
      id: 'streaming',
      label: formatMessage({ id: `dbi_streaming` }),
      disabled: false,
      component: (
        <Streaming
          isBasicLoading={loading}
          gameId={gameId}
          entityType={entityType}
          tabSegment={tabSegment}
          isCalibrated={isCalibrated}
          appInfoList={appInfoList}
          appIdListAll={appIdListAll}
          appIds={appIdList}
          basicInfo={basicInfo}
          moduleName={moduleName}
          activeId={activeId}
          activeSegment={activeSegment}
          setActiveSegment={setActiveSegment}
          isTwoMonths={isTwoMonths}
          urlFilterValue={urlFilterValue}
        />
      ),
    },
  ];

  const tabsOverviewStats = [
    {
      id: 'overview',
      label: formatMessage({ id: `dbi_overview` }),
      disabled: false,
      component: (
        <Overlay
          gameId={gameId}
          entityType={entityType}
          isCalibrated={isCalibrated}
          moduleName={moduleName}
          basicInfo={basicInfo}
          basicInfoOthers={basicInfoOthers}
          appInfoList={appInfoList}
          loading={loading}
          loadingSub={loadingSub}
          appIdList={appIdList}
          regionType={marketRegionType}
          regions={marketRegionValue}
          isSingle={isSingle}
          activeId={activeId}
          gotoSingle={receiverSum}
          setActiveId={setActiveId}
          setHref={setHref}
          isTwoMonths={isTwoMonths}
          sourseType={sourse}
          timeType={timeType}
          detailIndex={detailIndex}
          setDetailIndex={setDetailIndex}
          hrefFlag={hrefFlag}
          unPublishedAppIdList={unPublishedAppIdList}
          inactiveAppIdList={inactiveAppIdList}
          setActiveSegment={setActiveSegment}
          receiveSumFun={changeAppIds}
          setAppIdList={setAppIdList}
          appIdListAll={appIdListAll}
          releaseInFortyDay={basicInfo?.is_forty_days}
          urlFilterValue={urlFilterValue}
          tableFeedBackData={tableFeedBackData}
          fetchTrueDataFeedbackHistory={fetchTrueDataFeedbackHistory}
          pageId={pageIdFeedBack}
          tableFeedBackDataTotal={tableFeedBackDataTotal}
          feedBackParams={feedBackParams}
          openFeedBackTable={openFeedBackTable}
          setOpenFeedBackTable={setOpenFeedBackTable}
          combineGameIdList={combineGameIdList}
          setGameData={setGameData}
          gameData={gameData}
          selectGameName={selectGameName}
          setSelectGameName={setSelectGameName}
          match={props?.match}
          setGameIdValue={setGameIdValue}
          setEntityTypeValue={setEntityTypeValue}
          definitionsLoading={definitionsLoading}
          genreOptionsMap={genreOptionsMap}
          filterTags={filterTags}
          gameDetails={gameDetails}
        />
      ),
    },
    {
      id: 'stats',
      label: formatMessage({ id: `dbi_stats` }),
      disabled: false,
      className: COMPETITOR_GUIDE_CLASSNAMES.ELEMENT4_HIGHLIGHT1,
      component: (
        <Stats
          isBasicLoading={loading}
          gameId={gameId}
          entityType={entityType}
          tabSegment={tabSegment}
          countryList={countryList}
          regionsCountries={regionsCountries}
          basicInfo={basicInfo}
          appIdListAll={appIdListAll}
          appIds={appIdList}
          unPublishedAppIdList={unPublishedAppIdList}
          tabType={'stats'}
          isCalibrated={isCalibrated}
          moduleName={moduleName}
          activeId={activeId}
          activeSegment={activeSegment}
          setActiveSegment={setActiveSegment}
          markManualStatsSegmentSwitch={markManualStatsSegmentSwitch}
          isManualStatsSegmentSwitch={isManualStatsSegmentSwitch}
          isTwoMonths={isTwoMonths}
          hasJapanSales={hasJapanSales}
          hasSteamData={combineGameIdList?.filter((item) => ['pc'].includes(item?.entity_type))?.length > 0}
          combineGameIdList={combineGameIdList}
          releaseInFortyDay={basicInfo?.is_forty_days}
          urlFilterValue={urlFilterValue}
        />
      ),
    },
  ];

  const tabsOverlap: any = [
    {
      id: 'overlap',
      label: (
        <Bubble
          dark
          content={isOverlapDisabled ? formatMessage({ id: 'dbi_info_data_detail_tab_nodata_disabled' }) : null}
        >
          {formatMessage({ id: 'dbi_overlap' })}
        </Bubble>
      ),
      disabled: isOverlapDisabled,
      component: (
        <Overlap
          loading={loading || overlapAppIdsLoading}
          entityType={entityType}
          setActiveId={setActiveId}
          gameId={gameId}
          gameName={basicInfo?.name}
          basicInfo={basicInfo}
          tabSegment={tabSegment}
          isCalibrated={isCalibrated}
          urlFilterValue={urlFilterValue}
        />
      ),
    },
  ];

  const tabsOverlapSteam: any = [
    {
      id: 'overlap',
      label: (
        <Bubble
          dark
          content={isDisabledSteamOverlap ? formatMessage({ id: 'dbi_info_data_detail_tab_nodata_disabled' }) : null}
        >
          {formatMessage({
            id: entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE ? 'dbi_steam_overlap' : 'dbi_overlap',
          })}
        </Bubble>
      ),
      disabled: isDisabledSteamOverlap,
      component: (
        <OverlapSteam
          loading={loading}
          overlapAppIdsLoading={overlapAppIdsLoading}
          entityType={entityType}
          gameId={gameId}
          appOverlapSteamId={appOverlapSteamId}
          basicInfo={basicInfo}
        />
      ),
    },
  ];

  const tabsCombineInfoOverviewTrends: any = [
    {
      id: 'gameInfo',
      label: formatMessage({ id: `dbi_gameinfo` }),
      disabled: false,
      component: (
        <GameInfo
          gameId={gameId}
          entityType={entityType}
          isCalibrated={isCalibrated}
          moduleName={moduleName}
          basicInfo={basicInfo}
          basicInfoOthers={basicInfoOthers}
          loading={loading}
          appIdList={appIdList}
          isSingle={isSingle}
          activeId={activeId}
          setDetailIndex={setDetailIndex}
          appIdListAll={appIdListAll}
          gameDetails={gameDetails}
        />
      ),
    },
    {
      id: 'overview',
      label: formatMessage({ id: `dbi_kpi_overview` }),
      disabled: false,
      component: (
        <KPIOverview
          gameId={gameIdValue}
          entityType={entityTypeValue}
          basicInfo={basicInfo}
          combineGameIdList={combineGameIdList}
          loading={loading}
          moduleName={moduleName}
          activeId={activeId}
          setActiveId={setActiveId}
          setActiveSegment={setActiveSegment}
          tableFeedBackData={tableFeedBackData}
          fetchTrueDataFeedbackHistory={fetchTrueDataFeedbackHistory}
          pageId={pageIdFeedBack}
          tableFeedBackDataTotal={tableFeedBackDataTotal}
          feedBackParams={feedBackParams}
          openFeedBackTable={openFeedBackTable}
          setOpenFeedBackTable={setOpenFeedBackTable}
          setGameData={setGameData}
          gameData={gameData}
          selectGameName={selectGameName}
          setSelectGameName={setSelectGameName}
          match={props?.match}
          setGameIdValue={setGameIdValue}
          setEntityTypeValue={setEntityTypeValue}
        />
      ),
    },
    {
      id: 'stats',
      label: formatMessage({ id: `dbi_kpi_trends` }),
      disabled: false,
      className: COMPETITOR_GUIDE_CLASSNAMES.ELEMENT4_HIGHLIGHT1,
      component: (
        <KPITrends
          isBasicLoading={loading}
          gameId={gameId}
          opinionId={opinionId}
          combineGameIdList={combineGameIdList}
          tabType={'kpiTrends'}
          entityType={entityType}
          releaseTime={releaseTime}
          regionsCountries={regionsCountries}
          basicInfo={basicInfo}
          activeSegment={activeSegment}
          feedBackParams={feedBackParams}
        />
      ),
    },
    {
      id: 'originalStats',
      label: formatMessage({ id: `dbi_stats` }),
      disabled: false,
      className: COMPETITOR_GUIDE_CLASSNAMES.ELEMENT4_HIGHLIGHT1,
      component: (
        <Stats
          isBasicLoading={loading}
          gameId={gameId}
          entityType={entityType}
          tabSegment={tabSegment}
          countryList={countryList}
          regionsCountries={regionsCountries}
          basicInfo={basicInfo}
          appIdListAll={appIdListAll}
          appIds={appIdList}
          unPublishedAppIdList={unPublishedAppIdList}
          tabType={'stats'}
          isCalibrated={isCalibrated}
          moduleName={moduleName}
          activeId={activeId}
          activeSegment={activeSegment}
          setActiveSegment={setActiveSegment}
          isTwoMonths={isTwoMonths}
          hasJapanSales={hasJapanSales}
          hasSteamData={combineGameIdList?.filter((item) => ['pc'].includes(item?.entity_type))?.length > 0}
          combineGameIdList={combineGameIdList}
          releaseInFortyDay={basicInfo?.is_forty_days}
          urlFilterValue={urlFilterValue}
        />
      ),
    },
  ];

  const tabsOpinions: any = [
    {
      id: 'opinions',
      label: (
        <Bubble dark content={!showOpinion ? formatMessage({ id: 'dbi_info_data_opinion_disabled' }) : null}>
          <div className="dbi-tab-flex">
            {formatMessage({ id: `dbi_opinions` })}
            <SvgIcon type={'aigc-share'} className="dbd-tab-icon" style={{ marginLeft: 7 }} />
          </div>
        </Bubble>
      ),
      disabled: !showOpinion,
      component: (
        <Opinions
          gameId={gameId}
          entityType={entityType}
          tabSegment={tabSegment}
          moduleName={moduleName}
          activeId={activeId}
          countryList={countryList}
          regionsCountries={regionsCountries}
        />
      ),
    },
  ];

  const tabsDemographics: any = [
    {
      id: 'demographics',
      label: (
        <Bubble
          dark
          content={!isDemographics ? formatMessage({ id: 'dbi_info_data_detail_tab_nodata_disabled' }) : null}
        >
          {formatMessage({ id: 'dbi_demographics' })}
        </Bubble>
      ),
      disabled: !isDemographics,
      component: (
        <Demographics
          gameId={gameId}
          entityType={entityType}
          tabSegment={tabSegment}
          loading={loading}
          isCalibrated={isCalibrated}
          appInfoList={appInfoList}
          appIdList={appIdListAll}
          basicInfo={basicInfo}
          demographicsIdsList={demographicsIdsList}
          demographicsIdsLoaded={demographicsIdsLoaded}
          appIds={appIdList}
          urlFilterValue={urlFilterValue}
        />
      ),
    },
  ];

  const tabsDataReport: any = [
    {
      id: 'dataReport',
      label: (
        <Bubble dark content={isDisabledDataReport ? formatMessage({ id: 'dbi_info_data_report_disabled' }) : null}>
          {formatMessage({ id: 'dbi_data_report' })}
        </Bubble>
      ),
      disabled: isDisabledDataReport,
    },
  ];

  const tabsGameComparison: any = [
    {
      id: 'gameComparison',
      label: (
        <Bubble dark content={
          <div style={{ width: 300 }}>
            {formatMessage({ id: 'dbi_game_comparison_tooltip' })}
          </div>
        }>
          <div className="dbi-tab-flex">
            {formatMessage({ id: 'dbi_game_comparison' })}
            <SvgIcon type={'aigc-share'} className="dbd-tab-icon" style={{ marginLeft: 7 }} />
          </div>
        </Bubble>
      ),
      disabled: false,
    },
  ];

  const tabOptionsMap: {
    [key in IGameType]: any[];
  } = {
    mobile: [...tabsOverviewStats, ...tabs, ...tabsDemographics, ...tabsOverlap, ...tabsGameComparison, ...tabsOpinions, ...tabsDataReport],
    pc: [...tabsOverviewStats, ...tabs, ...tabsOverlapSteam, ...tabsOpinions, ...tabsDataReport],
    console: [...tabsOverviewStats, ...tabs, ...tabsOpinions, ...tabsDataReport],
    [PC_CONSOLE_COMBINE_ENTITY_TYPE]: [
      ...tabsCombineInfoOverviewTrends,
      ...tabs,
      ...tabsOverlapSteam,
      ...tabsGameComparison,
      ...tabsOpinions,
      ...tabsDataReport,
    ],
  };

  const getMobileDetailPermissionPageId = (tabId: string): string | undefined => {
    switch (tabId) {
      case 'overview':
        return dbiPageLogMes.mobileGameDetailsOverview.pageId;
      case 'stats':
        return getStatsPageLogMes('mobile', activeSegment)?.pageId;
      case 'countries':
        return getCountroesPageLogMes('mobile', activeSegment)?.pageId;
      case 'demographics':
        return dbiPageLogMes.mobileGameDetailsDemographics.pageId;
      case 'overlap':
        return dbiPageLogMes.mobileGameDetailsOverlap.pageId;
      default:
        return undefined;
    }
  };

  const originalTabOptions = tabOptionsMap[entityType] || tabs;
  const tabOptions = originalTabOptions.map((tab) => {
    const permissionPageId = getMobileDetailPermissionPageId(tab.id);
    const shouldCheckPermission =
      entityType === 'mobile' &&
      !MOBILE_DETAIL_PERMISSION_EXCLUDED_TAB_IDS.includes(tab.id) &&
      !!tab.component &&
      !!permissionPageId;

    if (!shouldCheckPermission) return tab;

    return {
      ...tab,
      component: (
        <PermissionGuard pageId={permissionPageId} style={MOBILE_DETAIL_PERMISSION_GUARD_STYLE}>
          {tab.component}
        </PermissionGuard>
      ),
    };
  });

  const getParentMenuPath = () => {
    const currentPath = window.location.pathname;
    const pathParts = currentPath.split('/');

    // 查找 gamesDetails 在路径中的位置
    const gamesDetailsIndex = pathParts.findIndex(part => part === 'gamesDetails');
    if (gamesDetailsIndex !== -1) {
      // 找到 gamesDetails，取它之前的所有部分作为母菜单路径
      const parentPath = pathParts.slice(0, gamesDetailsIndex).join('/');
      // 去掉 basePath
      return parentPath.replace(new RegExp(`^${basePath}`), '');
    }

    // 兜底方案：返回情报系统首页
    return '/intelligence';
  };

  const handleBack = () => {
    let hasGoBack = false;

    // 监听 popstate 事件，判断 goBack 是否真的跳转了
    const onPopState = () => {
      hasGoBack = true;
      window.removeEventListener('popstate', onPopState);
    };
    window.addEventListener('popstate', onPopState);

    history.goBack();

    setTimeout(() => {
      if (!hasGoBack) {
        // goBack 没有生效，兜底跳转
        const parentMenuPath = getParentMenuPath();

        // 针对PCConsoleGames的特殊处理
        if (parentMenuPath.includes('pcConsoleGames')) {
          window.location.href = parentMenuPath;
          return;
        }

        history.push(parentMenuPath);
        window.removeEventListener('popstate', onPopState);
      }
    }, 300); // 300ms 内没跳转就 push
  };

  const goBackHandle = () => {
    if (topchartsState.appIdsBackup?.length > 1) {
      setDetailIndex([]);
      getHead_info(topchartsState.appIdsBackup[topchartsState.appIdsBackup?.length - 2]);
      setAppIdList(topchartsState.appIdsBackup[topchartsState.appIdsBackup?.length - 2]);
      const arr = topchartsState.appIdsBackup;
      arr.splice(arr?.length - 1, 1);
      dispatch({ type: `${DBI_TOPCHARTS}/setAppIdsBackup`, payload: arr });
    } else {
      setDetailIndex([]);
      dispatch({
        type: `${DBI_TOPCHARTS}/resetTopchartJumpParam`,
        payload: '',
      });
      dispatch({ type: `${DBI_TOPCHARTS}/setIsOperation`, payload: false });
      if (ifUnifiedGo) {
        handleBack();
      } else {
        getHead_info([]);
      }
    }
  };

  const container = useResetPositionWhenTabChange(activeId, gameId);

  const changeTabs = (tab: any) => {
    // pc console的舆情详情，暂时处理为直接跳转到舆情系统
    if (tab.id === 'opinions') {
      const id = entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE ? opinionId : gameId;

      // 临时方案，针对Gloabl环境下，有以下三款游戏的舆情权限的用户，跳转到舆情Feeds页面
      if (IS_GLOBAL && OPINIONFEEDSGAMES?.includes(id)) {
        window.open(`${basePath}/opinion/Feeds/Feeds?gameid=${id}`, '_blank');
      } else {
        window.open(`${basePath}/opinion/Overview/KeyMetrics?gameid=${id}`, '_blank');
      }
    } else if (tab.id === 'dataReport') {
      if (dataReportGameId) {
        window.open(`${basePath}/intelligence/reports/trendingGames/${dataReportGameId}`, '_blank');
      }
    } else if (tab.id === 'gameComparison') {
      // Game Comparison tab - navigate to Compare page with current game + competitors
      navigateToComparison('tab');
    } else {
      setActiveId(tab.id);
      // 判断是否是在stats/conuntries之间跳转, 是才继承activeSegment， 不是则清空activeSegment
      // 融合ID游戏，不需要继承
      const keeActiveSegement = ['originalStats', 'countries'].includes(tab.id);
      /* const keeActiveSegement =
        entityType !== PC_CONSOLE_COMBINE_ENTITY_TYPE &&
        ['originalStats', 'countries'].includes(tab.id); */
      if (keeActiveSegement) {
        /* Stats/Countries切换时，最早时间是一样的，不需要重新请求接口 */
        dispatch({
          type: `${DBI_TOPCHARTS}/setIsNeedEarliestUpdate`,
          payload: false,
        });
      }
      const realActiveSegment = keeActiveSegement && activeSegment ? activeSegment : '';
      setActiveSegment(realActiveSegment);
      history.replace(
        `/intelligence/topCharts/${moduleName || 'mobileGames'}/gamesDetails/${gameId}/${tab.id}${
          realActiveSegment ? `/${realActiveSegment}` : ''
        }`,
      );
    }
  };

  const info30Note = async (note?: any) => {
    let params: any = {};
    const today = moment(Date.now()).format('YYYY-MM-DD');
    if (note) {
      params = {
        action: 'set',
        key: 'showInfo30Note',
        value: '',
      };
      if (typeof note === 'number') {
        params.value = moment(today).subtract(-note, 'day').format('YYYY-MM-DD');
      } else {
        params.value = note;
      }
    } else {
      params = {
        action: 'get',
        keys: ['showInfo30Note'],
      };
    }

    const { showInfo30Note } = await fetchUserSearchTrendingStatus(params);
    if (showInfo30Note === 'true') {
      setInfoNote(false);
    } else if (showInfo30Note) {
      setInfoNote(moment(showInfo30Note).isBefore(moment(today)));
    } else {
      setInfoNote(true);
    }
  };

  return (
    <Content
      ref={container}
      className={classNames({
        'dbi-topcharts-detail': true,
        'dbi-console-details': isConsoleOrPCConsoleCombine,
      })}
    >
      <HeaderDetails
        title={
          ifUnifiedGo
            ? formatMessage({ id: `dbi_unified_game_details` })
            : formatMessage({ id: `dbi_edition_game_details` })
        }
        className="games-bg"
        activeId={activeId}
        entityType={entityType}
        goBackHandle={goBackHandle}
        operation={
          <PublicTrueData
            publicTrueDataReportBtnLogKey="gameDetailsHeaderTrueAllDataReport"
            gameId={gameIdValue}
            entityType={entityTypeValue}
            fetchTrueDataFeedbackHistory={fetchTrueDataFeedbackHistory}
            pageId={pageIdFeedBack}
            isNeedSearchGame={true}
            setGameData={setGameData}
            gameData={gameData}
            selectGameName={selectGameName}
            match={{ ...props?.match, entityType }}
            setSelectGameName={setSelectGameName}
            isGameDetail={true}
            buttonKey={'public_true_data'}
            setGameIdValue={setGameIdValue}
            setEntityTypeValue={setEntityTypeValue}
            activeId={activeId}
          />
          //   <TrueDataFeedback/>
        }
      >
        {headLoading || overlapAppIdsLoading ? (
          <Loading content={formatMessage({ id: 'common_loading' })} style={{ height: 96, color: '#262832' }} />
        ) : (
          <>
            <HeaderComonents
              basicInfo={basicInfo}
              gameDetails={gameDetails}
              genreOptionsMap={genreOptionsMap}
              appIdListAll={appIdListAll}
              req={req}
              receiveSumFun={changeAppIds}
              setDetailIndex={setDetailIndex}
              appIdList={appIdList}
              setAppIdList={setAppIdList}
              isIegg={isIegg}
              entityType={entityType}
              type={moduleName}
              moduleName={moduleName}
              gameId={gameId}
              userInfo={userInfo}
              activeId={activeId}
              data={list}
              storage={storage}
              combineGameIdList={combineGameIdList}
              isOverlapDisabled={isOverlapDisabled}
              isDisabledSteamOverlap={isDisabledSteamOverlap}
              releaseTime={releaseTime}
            />
            <div className="header-tab">
              <Tabs
                ceiling
                className="dbi-user-guide__game-details-tabs"
                newMarkIdsMappingKey={newMarkIdsMappingKey}
                tabs={tabOptions}
                animated={false}
                activeId={activeId}
                onActive={(tab) => {
                  changeTabs(tab);
                }}
              />
            </div>
          </>
        )}
      </HeaderDetails>

      {/* 头部吸顶结构 */}
      <Content.Body
        className={classNames({
          'dbi-topcharts-high-pos': entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE && activeId === 'stats',
        })}
        full
      >
        <FixedHeader>
          <div className="dbi-fixedheader-infobox">
            <Icon
              className="dbi-fixedheader-infobox-back"
              type="btnback"
              onClick={() => {
                goBackHandle();
              }}
            />
            <GameImage
              className={classNames({
                'dbi-fixedheader-gameinfo-avatar': true,
                'dbi-gameinfo-avatar--mobile': entityType === 'mobile',
                'dbi-gameinfo-avatar--pc': entityType === 'pc',
                'dbi-gameinfo-avatar--console': isConsoleOrPCConsoleCombine,
              })}
              src={basicInfo?.cover}
            />
            <div className="dbi-fixedheader-gameinfo-name">{basicInfo?.name}</div>
          </div>

          <div className="dbi-fixedheader-tabs">
            <Tabs
              ceiling
              newMarkIdsMappingKey={newMarkIdsMappingKey}
              tabs={tabOptions}
              animated={false}
              activeId={activeId}
              onActive={(tab: any) => {
                changeTabs(tab);
              }}
            />
          </div>
        </FixedHeader>
        <MarqueeBanner />
        <>
          {loading ? (
            <div style={{ height: 'calc(100vh - 187px - 60px)', color: '#262832' }}>
              <Loading content={formatMessage({ id: 'common_loading' })} />
            </div>
          ) : (
            tabOptions.map((e) => <div key={e.id}>{e.id === activeId ? e.component : ''}</div>)
          )}
        </>
      </Content.Body>
      {ifShowDashboardTips && (
        <JumpDashboardModal
          visible={ifShowDashboardTips}
          setModalVisible={setIfShowDashboardTips}
          dashboardGameCode={dashboardGameCode}
        />
      )}
      {/* 弹框提示 */}
      <Modal
        size={500}
        className="game-detail-info"
        visible={infoNote}
        onClose={() => setInfoNote(false)}
        caption={<div>{formatMessage({ id: 'dbi_confirm_note' })}</div>}
      >
        <Modal.Body>{formatMessage({ id: 'dbi_pc_console_content' })}</Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            loading={overlapAppIdsLoading}
            onClick={() => {
              info30Note(30);
              setInfoNote(false);
              const combineEntityData = combineGameIdList?.find((item) => item?.entity_type === PC_CONSOLE_COMBINE_ENTITY_TYPE);
              const combineId = combineEntityData?.id || '';
              if (!!combineId) {
                // 跳转页面
                history.push(`/intelligence/topCharts/pcConsoleGames/gamesDetails/${combineId}/overview`);
              }
            }}
          >
            {formatMessage({ id: 'dbi_go_pc_console' })}
          </Button>
          <Button
            type="weak"
            onClick={() => {
              info30Note(30);
              setInfoNote(false);
            }}
          >
            {formatMessage({ id: 'dbi_settings_saved' })}
          </Button>
          <div className="no-again">
            {/* value={taste} onChange={(value) => setTaste(value)} */}
            <Checkbox.Group
              onChange={() => {
                info30Note('true');
                setInfoNote(false);
              }}
            >
              <Checkbox name="la">{formatMessage({ id: 'dbi_not_again' })}</Checkbox>
            </Checkbox.Group>
          </div>
        </Modal.Footer>
      </Modal>
    </Content>
  );
}

/**
 * 游戏详情页前置守卫：URL 路由参数中的游戏 id 非法时直接展示无数据状态
 * 不渲染详情组件，避免详情页内 hooks 初始化及所有游戏数据接口请求执行
 * @param props - 页面原始 props，包含路由 match 及入口透传的 entityType 等
 */
function GameDetailsIdGuard(props: any) {
  const gameId = props?.match?.params?.id || '';

  if (!validateGameId(props?.entityType, gameId)) {
    return <NoData />;
  }

  return <MobileGamesDetails {...props} />;
}

export default connect((state: any) => ({
  topchartsState: state[DBI_TOPCHARTS],
  userInfo: state.home,
}))(GameDetailsIdGuard);
